// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 背调结果页面样式 */
.bcr-container {
  max-width: 1000px;
  margin: 20px auto;
  padding: 0 20px;
}

.bcr-loading-container, .bcr-empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.bcr-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bcr-card-title {
  font-size: 18px;
  font-weight: bold;
}

.bcr-overall-status {
  display: flex;
  align-items: center;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  color: white;
}

.bcr-status-icon {
  font-size: 48px;
  margin-right: 24px;
}

.bcr-status-info {
  flex: 1 1;
}

.bcr-status-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
}

.bcr-status-desc {
  font-size: 14px;
  opacity: 0.9;
}

.bcr-section-card {
  margin-bottom: 16px;
}

.bcr-section-content {
  padding: 8px 0;
}

.bcr-info-content {
  padding: 8px 0;
}

.bcr-info-row {
  display: flex;
  margin-bottom: 12px;
}

.bcr-info-label {
  width: 120px;
  color: #666;
  flex-shrink: 0;
}

.bcr-info-value {
  flex: 1 1;
  color: #333;
}

.bcr-tip-text {
  color: #999;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 16px;
}

.bcr-warning-text {
  color: #ff4d4f;
  font-weight: bold;
  margin-bottom: 16px;
}

.bcr-toggle-link {
  color: #1890ff;
  cursor: pointer;
  margin-left: 8px;
  font-weight: normal;
  -webkit-user-select: none;
          user-select: none;
}

.bcr-toggle-link:hover {
  text-decoration: underline;
}

.bcr-toggle-standalone {
  display: inline-block;
  margin: 0 0 12px 0;
}

.bcr-toggle-row {
  margin-top: 8px;
}

.bcr-case-list {
  margin: 16px 0;
}

.bcr-case-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.bcr-case-item:last-child {
  border-bottom: none;
}

.bcr-case-index {
  color: #666;
  margin-right: 12px;
  flex-shrink: 0;
}

.bcr-case-info {
  flex: 1 1;
  color: #666;
  line-height: 1.8;
}

.bcr-query-time {
  color: #999;
  font-size: 13px;
  margin-top: 16px;
}

.bcr-action-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/BackgroundCheckResult.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":["/* 背调结果页面样式 */\n.bcr-container {\n  max-width: 1000px;\n  margin: 20px auto;\n  padding: 0 20px;\n}\n\n.bcr-loading-container, .bcr-empty-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.bcr-card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.bcr-card-title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.bcr-overall-status {\n  display: flex;\n  align-items: center;\n  padding: 24px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  color: white;\n}\n\n.bcr-status-icon {\n  font-size: 48px;\n  margin-right: 24px;\n}\n\n.bcr-status-info {\n  flex: 1;\n}\n\n.bcr-status-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.bcr-status-desc {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.bcr-section-card {\n  margin-bottom: 16px;\n}\n\n.bcr-section-content {\n  padding: 8px 0;\n}\n\n.bcr-info-content {\n  padding: 8px 0;\n}\n\n.bcr-info-row {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.bcr-info-label {\n  width: 120px;\n  color: #666;\n  flex-shrink: 0;\n}\n\n.bcr-info-value {\n  flex: 1;\n  color: #333;\n}\n\n.bcr-tip-text {\n  color: #999;\n  font-size: 13px;\n  line-height: 1.6;\n  margin-bottom: 16px;\n}\n\n.bcr-warning-text {\n  color: #ff4d4f;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.bcr-toggle-link {\n  color: #1890ff;\n  cursor: pointer;\n  margin-left: 8px;\n  font-weight: normal;\n  user-select: none;\n}\n\n.bcr-toggle-link:hover {\n  text-decoration: underline;\n}\n\n.bcr-toggle-standalone {\n  display: inline-block;\n  margin: 0 0 12px 0;\n}\n\n.bcr-toggle-row {\n  margin-top: 8px;\n}\n\n.bcr-case-list {\n  margin: 16px 0;\n}\n\n.bcr-case-item {\n  display: flex;\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.bcr-case-item:last-child {\n  border-bottom: none;\n}\n\n.bcr-case-index {\n  color: #666;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.bcr-case-info {\n  flex: 1;\n  color: #666;\n  line-height: 1.8;\n}\n\n.bcr-query-time {\n  color: #999;\n  font-size: 13px;\n  margin-top: 16px;\n}\n\n.bcr-action-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
